import React from 'react';
import { Tag as AntTag } from 'antd';

/**
 * Wrapper component for Ant Design Tag
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Tag functionality including color, closable, and visible options.
 * 
 * @component
 * @example
 * import { Tag } from '../GeneralComponents/ui';
 * 
 * <Tag>Tag 1</Tag>
 * <Tag color="magenta">magenta</Tag>
 * <Tag color="red">red</Tag>
 * <Tag color="volcano">volcano</Tag>
 * <Tag closable onClose={onClose}>Closable Tag</Tag>
 * 
 * @see https://ant.design/components/tag/ - Ant Design Tag documentation
 */
const Tag = (props) => {
  return <AntTag {...props} />;
};

export default Tag;

